import $ from 'jquery'

import { button } from '../../../component/component'

import form from '../edit/form/form'

export default function(e, o, d){

  var insert = function(){

    var model = o.model.userMarkers

    var d = function(item){
      div.remove()
      o.search.update()
    }

    var c = function(item){
      div.remove()
    }

    var div =
      $('<div>')
      .css({
        position: 'fixed',
        top: '402px',
        width: '400px',
        left: 0,
        bottom: 0,
      })
      .append(
        form(o,model,null,d,c)
      )

    o.edit.append(div)

  }

  insert()

  e.preventDefault()
  // e.stopPropagation()

  // return false

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/insertUserMarker.js